// extracted by mini-css-extract-plugin
module.exports = {"langDd":"style_langDd__3pxfg"};